var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('the-header'),_c('the-alerts'),_c('div',{staticClass:"main-parent"},[_c('v-main',{attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path})],1),_c('the-footer')],1)],1),_c('the-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }